'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HoldInfoMessages;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

require('../styles/HoldInfoMessages.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HoldInfoMessages(_ref) {
  var _ref$messageIds = _ref.messageIds,
      messageIds = _ref$messageIds === undefined ? [] : _ref$messageIds;

  if (messageIds.length === 0) {
    return null;
  }
  return _react2.default.createElement(
    'div',
    null,
    messageIds.map(function (num) {
      return _react2.default.createElement(
        'div',
        { className: 'cp-hold-info-message' },
        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'hold_info_msg_block' + num })
      );
    })
  );
}

HoldInfoMessages.propTypes = {
  messageIds: _react.PropTypes.arrayOf(_react.PropTypes.number).isRequired
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-hold-info-messages/lib/components/HoldInfoMessages.component.js
// module id = 1487
// module chunks = 1